export const specialties = [
  "Accident and Emergency",
  "Anaesthesia",
  "Burns and Plastic",
  "Cardiothoracic",
  "Critical Care",
  "General Nursing",
  "Gerontology Nursing",
  "Mental Health",
  "Midwifery",
  "Neonatology Nursing",
  "Nephrology Nursing",
  "Occupational health Nursing",
  "Oncology Nursing",
  "Ophthalmic Nursing",
  "Oral-Dental Nursing",
  "Orthopaedic Nursing",
  "Otorhinolaryngology",
  "Paediatric Nursing",
  "Perioperative",
  "Public Health Nursing",
];

export const nursingSpecialties = [
  { specialty: "Accident and Emergency Nurse", abbreviation: "RAEN" },
  { specialty: "Burns and Plastic Nurse", abbreviation: "RBPN" },
  { specialty: "Cardiothoracic Nurse", abbreviation: "RCTN" },
  { specialty: "Critical Care Nurse", abbreviation: "RCCN" },
  { specialty: "Dental-Oral Nurse", abbreviation: "RDON" },
  { specialty: "General Nurse", abbreviation: "RN" },
  { specialty: "Gerontology Nurse", abbreviation: "RGN" },
  { specialty: "Mental/Psychiatric Health Nurse", abbreviation: "RPN" },
  { specialty: "Midwife", abbreviation: "RM" },
  { specialty: "Midwife Educator", abbreviation: "RME" },
  { specialty: "Neonatology Nurse", abbreviation: "RNntN" },
  { specialty: "Nephrology Nurse", abbreviation: "RNphN" },
  { specialty: "Nurse Administrator", abbreviation: "RNA" },
  { specialty: "Nurse Anaesthetist", abbreviation: "RNAs" },
  { specialty: "Nurse Educator", abbreviation: "RNE" },
  { specialty: "Occupational Health Nurse", abbreviation: "ROHN" },
  { specialty: "Oncology Nurse", abbreviation: "ROncN" },
  { specialty: "Ophthalmic Nurse", abbreviation: "ROphN" },
  { specialty: "Orthopaedic Nurse", abbreviation: "RON" },
  { specialty: "Otorhinolaryngology Nurse", abbreviation: "ROrlN" },
  { specialty: "Paediatric Nurse", abbreviation: "RPdN" },
  { specialty: "Perioperative Nurse", abbreviation: "RPON" },
  { specialty: "Public Health Nurse", abbreviation: "RPHN" },
  { specialty: "Public Health Nurse Educator", abbreviation: "RPHNE" },
];
